import React from 'react';
import { Box } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useColorScheme } from '../../contexts/ColorSchemeContext';

const ColorSchemeButton = ({ className, sx, iconSize = 24, variant = 'icon' }) => {
  const { resolvedMode, toggleColorScheme } = useColorScheme();
  const ToggleIcon = resolvedMode === 'dark' ? LightModeOutlinedIcon : DarkModeOutlinedIcon;
  const isSwitch = variant === 'switch';
  const buttonClassName = [
    className,
    isSwitch ? 'color-scheme-switch' : '',
    isSwitch && resolvedMode === 'dark' ? 'is-dark' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Box
      component="button"
      className={buttonClassName}
      onClick={toggleColorScheme}
      sx={sx}
      title={resolvedMode === 'dark' ? '라이트 모드' : '다크 모드'}
      aria-label={resolvedMode === 'dark' ? '라이트 모드로 전환' : '다크 모드로 전환'}
    >
      {isSwitch ? (
        <span className="color-scheme-switch-track" aria-hidden="true">
          <span className="color-scheme-switch-thumb" />
          <span className="color-scheme-switch-icon color-scheme-switch-icon-sun">
            <LightModeOutlinedIcon sx={{ fontSize: 16 }} />
          </span>
          <span className="color-scheme-switch-icon color-scheme-switch-icon-moon">
            <DarkModeOutlinedIcon sx={{ fontSize: 16 }} />
          </span>
        </span>
      ) : (
        <ToggleIcon sx={{ fontSize: iconSize }} />
      )}
    </Box>
  );
};

export default ColorSchemeButton;
